import { render, staticRenderFns } from "./approval-collection-index.vue?vue&type=template&id=5710ec29&scoped=true"
import script from "./approval-collection-index.vue?vue&type=script&lang=js"
export * from "./approval-collection-index.vue?vue&type=script&lang=js"
import style0 from "./approval-collection-index.vue?vue&type=style&index=0&id=5710ec29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710ec29",
  null
  
)

export default component.exports